import { type ButtonHTMLAttributes, forwardRef } from 'react'

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'ghost'
  size?: 'sm' | 'md' | 'lg'
  fullWidth?: boolean
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ variant = 'primary', size = 'md', fullWidth = false, className = '', children, disabled, ...props }, ref) => {
    const baseClasses = 'font-medium rounded-lg transition-all cursor-pointer border-none'

    const variantClasses = {
      primary: 'bg-gradient-to-br from-indigo-500 to-purple-600 text-white shadow-md hover:opacity-90 active:opacity-70',
      secondary: 'bg-white/10 text-white hover:bg-white/20',
      ghost: 'bg-transparent text-white/60 hover:bg-white/10 hover:text-white'
    }

    const sizeClasses = {
      sm: 'text-xs py-2 px-3',
      md: 'text-sm py-2.5 px-4',
      lg: 'text-base py-3 px-5'
    }

    const disabledClasses = disabled ? 'disabled:bg-white/10 disabled:text-white/30 disabled:cursor-not-allowed disabled:shadow-none' : ''
    const widthClass = fullWidth ? 'w-full' : ''

    return (
      <button
        ref={ref}
        className={`${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${disabledClasses} ${widthClass} ${className}`}
        disabled={disabled}
        {...props}
      >
        {children}
      </button>
    )
  }
)

Button.displayName = 'Button'
